import { DefaultService } from '@/services/DefaultService';

export default class AcertoDespesaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }
    
    find(id) {
        return this._http.get(`${this._env}/despesa/acerto-despesa/${id}.json`, 
        this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.handleError(err);
            });
    }
    findByUuid(uuid) {
        return this._http.get(`${this._env}/despesa/acerto-despesa/uuid/${uuid}.json`, 
        this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.handleError(err);
            });
    }

    findAll(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/despesa/acerto-despesa.json`), 
            filtros, 
            this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.handleError(err);
            });
    }
    findTotais(filtros){
        return this._http.post(encodeURI(`${this._env}/despesa/acerto-despesa/totais.json`), 
            filtros, 
            this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.handleError(err);
            });
    }
    save(form) {
        return this._http.post(`${this._env}/despesa/acerto-despesa`, 
        form, 
        this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    enviarParaAprocacao(uuid) {
        return this._http.get(`${this._env}/despesa/acerto-despesa/aprovacao/${uuid}.json`, 
        this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    enviarParaRevisao(uuid) {
        return this._http.get(`${this._env}/despesa/acerto-despesa/revisao/${uuid}.json`, 
        this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    aprovar(uuid, aprovacaoParcial) {
        return this._http.get(`${this._env}/despesa/acerto-despesa/aprovar/${aprovacaoParcial}/${uuid}.json`, 
        this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    reprovar(uuid, idmotivoregistro) {
        return this._http.get(`${this._env}/despesa/acerto-despesa/reprovar/${idmotivoregistro}/${uuid}.json`, 
        this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    exportarAcerto(idconfjasper, uuid) {
        let headCopy = { ...this._headers};
        headCopy.responseType = 'arraybuffer';
        return this._http.get(`${this._env}/despesa/acerto-despesa/${idconfjasper}/${uuid}/exportar`, 
        headCopy)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    remove(uuid) {
        return this._http
        .get(`${this._env}/despesa/acerto-despesa/remove?uuid=${uuid}`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}